<template>
    <div class="product__info__accordion">
        <button class="product__info__accordion__subheading" @click="handleArrowClick">
            {{heading}}
            <img :class="arrowIconClass" src="@/assets/images/decoration/arrow-shop.svg">
        </button>
        <div :class="infoClass">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'TextDropdown',
    props: {
        heading: {
            required: true,
            type: String,
        },
        expand: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    mounted() {
        this.isOpen = this.expand;
    },
    computed: {
        arrowIconClass() {
            const classStr = 'product__info__accordion__arrow';
            return this.isOpen ? `${classStr} ${classStr}--active` : classStr;
        },
        infoClass() {
            const classStr = 'accordion__md';
            return this.isOpen ? `${classStr} ${classStr}--active` : classStr;
        },
    },
    methods: {
        handleArrowClick() {
            this.isOpen = !this.isOpen;
        },
    },
};
</script>
